<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Turno confirmación</h1>
  <div>
    <mat-tab-group>
      <mat-tab label="Historial">

        <mat-form-field *ngIf="data && data.confirmationStatusId" appearance="standard" class="full-control">
          <mat-label>Observaciones</mat-label>
          <textarea formControlName="Observation" matInput></textarea>
        </mat-form-field>

        <div *ngIf="medicalAppointmentConfirmations && medicalAppointmentConfirmations.length > 0" class="observation-table-scroll">
          <table class="table-content">
            <tr>
              <th class="cell-date">Fecha</th>
              <th>Observaciones</th>
            </tr>

            <tr *ngFor="let obs of medicalAppointmentConfirmations">
              <td class="cell-date">{{obs.Date}}</td>
              <td><div style="width:100%; max-width:400px; word-wrap: break-word">{{obs.ConfirmationObservation}} </div></td>
            </tr>
          </table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="clearfix">
    <div class="pull-right">
      <button *ngIf="data.confirmationStatusId && !loadingAction" mat-button type="submit">Aceptar</button>
      <button *ngIf="!loadingAction" mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
    </div>
  </div>
</form>
